import { useMutation, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';
import {
  detailAnswersCustomers,
  editAnswers,
  listAnswersCustomers,
  listAnswersReplyDate,
  listAnswersSyntheticResearch,
  removeAnswers,
} from './Answers.service';
import { EditAnswersData, ListAnswersParams } from './Answers.types';
import notificationError from '@/utils/functions/notificationError';

// import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';

// export function useAnswers(quizId: number, params?: ListAnswersParams) {
//   const query = useQuery(['answers', 'quiz', quizId], () =>
//     listAnswers(quizId, params),
//   );

//   useServiceError(query.error);

//   return query;
// }

export function useAnswersReplyDate(
  quizId: number,
  params?: ListAnswersParams,
) {
  const query = useQuery(
    ['answers', 'quiz', quizId, 'reply-date', { ...params }],
    () => listAnswersReplyDate(quizId, params),
  );

  useServiceError(query.error);

  return query;
}

export function useAnswersCustomers(
  quizId: number,
  params?: ListAnswersParams,
) {
  const query = useQuery(
    ['answers/customers', quizId, { ...params }],
    () => listAnswersCustomers(quizId, params),
    {
      enabled: !!quizId,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useAnswersCustomerDetail(
  filter: { quizId: number; customerId?: number },
  params?: ListAnswersParams,
) {
  return useQuery(
    [
      'answers/customers/detail',
      filter.quizId,
      { ...params, customerId: filter.customerId },
    ],
    () => detailAnswersCustomers(filter, params),
    {
      enabled: !!filter.quizId && !!filter.customerId,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useAnswersSyntheticResearch(
  quizId: number,
  params?: ListAnswersParams,
) {
  const query = useQuery(
    ['answers', 'quiz', quizId, 'synthetic-research', { ...params }],
    () => listAnswersSyntheticResearch(quizId, params),
  );

  useServiceError(query.error);

  return query;
}

export function useEditAnswer(answerId: number) {
  const mutation = useMutation((obj: EditAnswersData) =>
    editAnswers(answerId, obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useRemoveAnswers() {
  const mutation = useMutation((id: number) => removeAnswers(id));

  useServiceError(mutation.error);

  return mutation;
}
